
const SettingAsideLeft = () => {
	return (
		null
	)
}

export default SettingAsideLeft;